import React from 'react';
import PropTypes from 'prop-types';
import {inject} from 'mobx-react';
import {action, computed} from 'mobx';
import autobind from 'autobind-decorator';

import {withI18n} from 'spa/Components/Context';

import ProgressiveBackgroundImage from 'spa/Components/ProgressiveBackgroundImage';

import ProgressiveImage from 'spa/Components/ProgressiveImage';

import 'spa/styles/home.less';
import '../../Home/HomeTherapistsSection.less';

@inject(({store: {screen, tracker}}) => ({
  screen,
  tracker,
}))
@withI18n
class HomeTherapistsSectionForDigital extends React.Component {
  static propTypes = {
    screen: PropTypes.shape({
      isDesktop: PropTypes.bool,
    }),
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    trackingCategory: PropTypes.string,
    trackingLocation: PropTypes.string,
  };

  @autobind
  @action('onClickReadMore - HomeTherapistsSectionForDigital')
  onClickReadMore() {
    const trackingData = {
      category: this.props.trackingCategory,
      label: 'Read our COVID-19 measures here',
    };

    if (this.props.trackingLocation) {
      trackingData.data = {
        page: this.props.trackingLocation,
      };
    }

    this.props.tracker.track('Clicked Read our COVID-19 measures here button', trackingData);
  }

  @computed get readMoreLink() {
    const {i18n} = this.context;

    if (i18n.umRegion === 'UK') {
      return 'https://urban.co/editorial/working-together-for-safer-at-home-treatments';
    }

    return 'https://urban.co/fr-fr/editorial/contribuons-au-bon-deroulement-des-soins-a-domicile/';
  }

  render() {
    const {i18n} = this.context;
    const {screen: {isDesktop}} = this.props;
    const {onClickReadMore, readMoreLink} = this;

    return (
      <div className="home-therapists-section home-content-section row">
        <div className="home-content-section__cell home-content-section__cell-text home-content-section-for-digital__cell-text home-content-section__cell-text home-content-section__cell-text--extra-padded-left  home-content-section--pull-bottom">
          <div className="home-content-section__text-content home-content-section__text-content--wide">
            <h2 className="home-content-section__title home-content-section-for-digital__title">{i18n._x('Professionals you can trust', 'Home therapist section title')}</h2>
            <p className="home-content-section__paragraph home-content-section-for-digital__paragraph">{i18n._x('There are no strangers in our community. We meet every pro first to make sure they’ve got the right qualifications to deliver a great session.', 'Home therapist section paragraph')}</p>
            <a
              className="button button--primary button--tiny-wide home-content-section__button home-content-section-for-digital__button"
              href={readMoreLink}
              onClick={onClickReadMore}
              rel="noopener noreferrer"
              target="_blank"
            >
              {i18n._x('Read our COVID-19 measures here', 'Homepage Read our COVID-19 measures here button')}
            </a>
          </div>
        </div>
        <ProgressiveBackgroundImage
          customClass="home-content-section__cell home-content-section__cell-image home-content-section-for-digital__cell-image home-therapists-section__cell-image"
          lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1585743199/b2c-art/home-2020/digital/img-homepage-practitioner.jpg"
          highResImg=""
          highResImg2x=""
          mediaQueries={[
            {
              query: '(max-width: 768px)',
              highResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1585743205/b2c-art/home-2020/digital/img-homepage-practitioner_2x.jpg',
              highResImg2x: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1585743206/b2c-art/home-2020/digital/img-homepage-practitioner_3x.jpg',
            },
          ]}
        >
          {isDesktop && (
            <ProgressiveImage
              className="home-therapists-section__cell-image-element"
              lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1585743199/b2c-art/home-2020/digital/img-homepage-practitioner.jpg"
              highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1585743205/b2c-art/home-2020/digital/img-homepage-practitioner_2x.jpg"
              highResImg2x="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1585743206/b2c-art/home-2020/digital/img-homepage-practitioner_3x.jpg"
            />
          )}
        </ProgressiveBackgroundImage>
      </div>
    );
  }
}

export default HomeTherapistsSectionForDigital;



// WEBPACK FOOTER //
// ./spa/Pages/Home2020/digital/HomeTherapistsSectionForDigital.jsx